import { StoreState } from '@shared/models/interfaces/store'
import { Nullable } from '@shared/models/types/primary'

export const isNull = <T>(arg: Nullable<T>) => {
  return arg === null
}

export const executeWithNullableArgs = <T>(
  cbArg: StoreState<T>,
  cb: <T>(model?: StoreState<T>) => boolean
) => {
  if (isNull(cbArg.data)) {
    return
  }

  return cb(cbArg)
}
